import {
  INIT_CUSTOMER,
  FETCH_CUSTOMER_LIST_START,
  FETCH_CUSTOMER_LIST_SUCCESS,
  FETCH_CUSTOMER_LIST_ERROR,
  FETCH_CUSTOMER_DETAIL,
  EDIT_CUSTOMER_RECORD,
  TOAST,
  CUSTOMER_CURRENCIES_PROVIDER_DD,
  CUSTOMER_COUNTRIES_PROVIDER_DD,
  DROPDOWN_TYPES,
} from "../../../constants/action-types/customer";
import { decorateEmptyGridValues } from "../../../utils/table/gridUtils";

const transformCustomerData = (data) => {
  const rows = data.map((item) => {
    const row = {
      id: item.id,
      name: item.name,
      tax_no: item.tax_no,
      crm_id: item.crm_id,
      rate: item.rate,
      order_cnt: item.order_cnt,
      invoice_cnt: item.invoice_cnt,
      phone: item.phone,
    };

    const decoratedRow = {};
    Object.keys(row).forEach((key) => {
      decoratedRow[key] = decorateEmptyGridValues(row[key]);
    });

    return decoratedRow;
  });

  return { customerList: { rows } };
};

const formFieldValueMap = {
  id: "",
  cust_type: false,
  due_days: null,
  cont_name: "",
  revenue_id: null,
  tax_id: null,
  name: "",
  oprtng_name: "",
  site_url: "",
  email: "",
  secondary_email_id: "",
  rate: 0,
  address1: "",
  address2: "",
  phone: null,
  phone2: null,
  billing_country: null,
  billing_state: "",
  billing_city: "",
  billing_zip_code: "",
  shipping_country: null,
  shipping_state: "",
  shipping_city: "",
  shipping_zip_code: "",
  currency_id: null,
  broker: false,
  broker_id: null,
  tax_no: null,
  crm_id: null,
  info: null,
  eob_id: "",
  invoice_by: null,
  service_pln_type: null,
  pg_id: null,
  customer_status: null,
  asset_id: null,
  order_cnt: 0,
  invoice_cnt: 0,
};


const INITIAL_STATE = {
  formFieldValueMap,
  customerList: [],
  customerCurrenciesProviderDD: {},
  customerCountriesProviderDD: {},
  taxTypeDD: [],
  revenueTypeDD: [],
  paginationInfo: null,
  isLoading: false,
  error: null,
  isCustomerDetailSuccess: false,
  isCustomerDetailError: false,
  isEditCustomerSuccess: false,
  isEditCustomerError: false,
};

export const customerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INIT_CUSTOMER:
      return { ...INITIAL_STATE, isLoadingPage: true };

    case FETCH_CUSTOMER_LIST_START:
    case CUSTOMER_CURRENCIES_PROVIDER_DD.START:
    case CUSTOMER_COUNTRIES_PROVIDER_DD.START:
    case DROPDOWN_TYPES.TAX_TYPE.START:
    case DROPDOWN_TYPES.REVENUE_TYPE.START:
      return { ...state, isLoading: true };

    case FETCH_CUSTOMER_LIST_SUCCESS: {
      const { page, _embedded } = action.payload;
      const { content } = _embedded;

      const { customerList } = transformCustomerData(content);

      return {
        ...state,
        customerList,
        paginationInfo: {
          pageSize: page.size,
          totalRecords: page.total_elements,
          totalPages: page.total_pages,
          pageNumber: page.number,
        },
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
      };
    }

    case FETCH_CUSTOMER_LIST_ERROR:
      return {
        ...state,
        customerList: [],
        isLoading: false,
        error: action.payload,
        isLoadingPage: false,
        isPageLevelError: true,
      };

    case FETCH_CUSTOMER_DETAIL.SUCCESS: {
      const data = action.payload;

      const updatedForm = {
        id: data.id || "",
        cust_type: data.cust_type || false,
        revenue_id: data.revenue_id || null,
        tax_id: data.tax_id || null,
        due_days: data.due_days || null,
        cont_name: data.cont_name || "",
        name: data.name || "",
        oprtng_name: data.oprtng_name || "",
        site_url: data.site_url || "",
        email: data.email || "",
        secondary_email_id: data.secondary_email_id || "",
        rate: data.rate || 0,
        address1: data.address1 || "",
        address2: data.address2 || "",
        phone: data.phone || null,
        phone2: data.phone2 || null,
        billing_country: data.billing_country?.key || null,
        billing_state: data.billing_state || "",
        billing_city: data.billing_city || "",
        billing_zip_code: data.billing_zip_code || "",
        shipping_country: data.shipping_country?.key || null,
        shipping_state: data.shipping_state || "",
        shipping_city: data.shipping_city || "",
        shipping_zip_code: data.shipping_zip_code || "",
        currency_id: data.currency_id || null,
        broker: data.broker || false,
        broker_id: data.broker_id || null,
        tax_no: data.tax_no || null,
        crm_id: data.crm_id || null,
        info: data.info || null,
        eob_id: data.eob_id || "",
        invoice_by: data.invoice_by || null,
        service_pln_type: data.service_pln_type || null,
        pg_id: data.pg_id || null,
        customer_status: data.customer_status || null,
        asset_id: data.asset_id || null,
        order_cnt: data.order_cnt || 0,
        invoice_cnt: data.invoice_cnt || 0,
      };
      

      return {
        ...state,
        formFieldValueMap: updatedForm,
        isLoading: false,
        isCustomerDetailSuccess: true,
        isCustomerDetailError: false,
        error: null,
      };
    }

    case FETCH_CUSTOMER_DETAIL.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isCustomerDetailSuccess: false,
        isCustomerDetailError: true,
      };
    }

    case EDIT_CUSTOMER_RECORD.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isEditCustomerSuccess: true,
        isEditCustomerError: false,
      };

    case EDIT_CUSTOMER_RECORD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isEditCustomerSuccess: false,
        isEditCustomerError: true,
      };
    }

    case CUSTOMER_CURRENCIES_PROVIDER_DD.SUCCESS: {
      const { content } = action.payload;
      return {
        ...state,
        isLoading: false,
        customerCurrenciesProviderDD: content,
      };
    }

    case CUSTOMER_CURRENCIES_PROVIDER_DD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }

    case CUSTOMER_COUNTRIES_PROVIDER_DD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
      };
    }

    case CUSTOMER_COUNTRIES_PROVIDER_DD.SUCCESS: {
      const { content } = action.payload;
      return {
        ...state,
        isLoading: false,
        customerCountriesProviderDD: content,
      };
    }

    case DROPDOWN_TYPES.TAX_TYPE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        taxTypeDD: action.payload,
      };
    }

    case DROPDOWN_TYPES.REVENUE_TYPE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        revenueTypeDD: action.payload,
      };
    }
    case DROPDOWN_TYPES.TAX_TYPE.ERROR:
    case DROPDOWN_TYPES.REVENUE_TYPE.ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case TOAST.RESET:
      return {
        ...state,
        isCustomerDetailError: false,
        isEditCustomerSuccess: false,
        isEditCustomerError: false,
      };

    default:
      return state;
  }
};
